import { unminifyError, unminifyStackTrace } from '@sgme/stacktrace';
import { Component, ErrorInfo } from 'react';
import { getFrontLogger } from 'utils/loggers/FrontLogger';

import type { UnderlyingGridLegacyComponent, UnderlyingGridLegacyProps } from './UnderlyingsGridLegacy';

const frontLogger = getFrontLogger();

export const errorBoundary = (WrappedComponent: typeof UnderlyingGridLegacyComponent) =>
  class ErrorBoundary extends Component<UnderlyingGridLegacyProps> {
    public state = {
      hasError: false,
    };

    public static getDerivedStateFromError() {
      return { hasError: true };
    }

    public async componentDidCatch(error: Error, errorInfo: ErrorInfo) {
      const err = await unminifyError(error);
      const errInfo = unminifyStackTrace(errorInfo.componentStack);
      frontLogger.error(
        'An error occurred when displaying underlying selection {@FrontError} {@ReactError}',
        err,
        errInfo,
      );
    }

    public render() {
      if (this.state.hasError) {
        return null;
      }

      return <WrappedComponent {...this.props} />;
    }
  };
